import React from "react";
import styled from "@emotion/styled";
import { Box, Paper } from "@mui/material";
import DisplayForm from "./DisplayForm";

const Container = styled(Paper)`
  display: flex;
  flexdirection: row;
  flex: 4 1 0;
  max-width: 672px;
`;

function DisplayFormContainer({ display }) {
  return (
    <Container>
      <Box sx={{ p: 2, width: "100%" }}>
        <DisplayForm />
      </Box>
    </Container>
  );
}

export default DisplayFormContainer;
